import React, { useState, useEffect } from 'react';
import { cssInJS } from '../../utils/styles';
import AddressPart from './deprecated-address-part';

interface Address {
  streetNumber?: string,
  streetName?: string,
  suite?: string,
  city?: string,
  county?: string,
  state?: string,
  postalCode?: string,
  country?: string,
}

interface Props {
  value?: {address: Address },
  disabled?: boolean,
  onChange?: (newVal: {address: Address}) => void,
  useApiPartKeys?: boolean
}

/**
 * @deprecated this file has been replaced by material
 */
const AddressField: React.FC<Props> = ({
  value,
  disabled = false,
  onChange,
  useApiPartKeys = false,
}: Props) => {
  const address = value || { address: {} };
  const [addressValue, setValue] = useState(address);
  const handleChange = (partKey: string, partValue: string) => {
    addressValue.address[partKey] = partValue;
    if (onChange) {
      onChange(addressValue);
    }
    setValue(addressValue);
  };

  useEffect(() => {
    setValue(address);
  }, [address]);

  const renderPart = (partName: string, altName: string, placeholder: string) => (
    <AddressPart
      part={useApiPartKeys ? altName : partName}
      value={addressValue.address[partName] || addressValue.address[altName] || ''}
      placeholder={placeholder}
      onChange={handleChange}
      disabled={disabled}
    />
  );

  return (
    // @ts-ignore
    <div className={styles.container}>
      {renderPart('streetNumber', 'sub_thoroughfare', 'Street Number')}
      {renderPart('streetName', 'thoroughfare', 'Street Name')}
      {renderPart('suite', 'suite', 'Apartment / Suite')}
      {renderPart('city', 'locality', 'City')}
      {renderPart('county', 'sub_admin_area', 'County')}
      {renderPart('state', 'admin_area', 'State')}
      {renderPart('postalCode', 'postal_code', 'Postal Code')}
      {renderPart('country', 'country', 'Country')}
    </div>
  );
};

const styles = cssInJS({
  container: {
    marginBottom: 4,
  },
});

export default AddressField;
